class TeamGroupCards extends DrupalBehavior {
    onContent(context) {
        const allSlidesContainers = context.querySelectorAll('.team-group-card:not(.disable-carousel) .team-group-card--slides-container');

        if (allSlidesContainers) {
            allSlidesContainers.forEach((slideGroup) => {
                this.init(slideGroup);
            });
        } else {
            return;
        }
    }

    init(slideGroup) {
        this.slideWrapper = slideGroup;
        this.slideWrapperWrapper = slideGroup.closest(
            '.team-group-card-section--list-item'
        );
        this.slides = slideGroup.querySelectorAll('.team-group-card--slide');
        this.slider = null;
        this.sliderPrevious = slideGroup.querySelector('.team-group-card--prev');
        this.sliderNext = slideGroup.querySelector('.team-group-card--next');
        this.showModal = this.slideWrapperWrapper.querySelector(
            '.team-group-card--modal-open.has-overlay'
        );
        this.closeModal = this.slideWrapperWrapper.querySelector(
            '.team-group-card--close'
        );

        this.bindEvents();
    }

    bindEvents() {
        this.showModalHandler = this.showModalHandler.bind(this);
        this.closeModalHandler = this.closeModalHandler.bind(this);
        this.previousTabHandler = this.previousTabHandler.bind(this);
        this.nextTabHandler = this.nextTabHandler.bind(this);
        this.keydownHandler = this.keydownHandler.bind(this); // Bind keydown event

        this.showModal.addEventListener('click', (event) => {
            this.showModalHandler(event);
        });

        this.closeModal.addEventListener('click', (event) => {
            this.closeModalHandler(event);
        });

        // Add event listener for the Escape key to close the modal
        document.addEventListener('keydown', this.keydownHandler);
    }

    keydownHandler(event) {
        if (event.key === 'Escape') {
            this.closeModalHandler();
        }
    }

    showModalHandler(event) {
        const slideWrapper = event.target.closest(
            '.team-group-card-section--list-item'
        );
        if (slideWrapper) {

            if (slideWrapper.getAttribute('data-shuffled') != '1') {
                this.shuffleItems(slideWrapper);
                slideWrapper.setAttribute('data-shuffled', 1);
            }

            slideWrapper.classList.add('show');
            document.body.classList.add('has-open-modal');

            if (!slideWrapper.classList.contains('slider-initialized')) {
                this.createSliderForModal(slideWrapper);
                slideWrapper.classList.add('slider-initialized');
            }
        }
    }

    shuffleItems(container) {

        var slideSelector = '.team-group-card--slide';
        var itemSelector = '.doctor-image-card';

        //later if you want to put it back

        //someParentElement.appendChild(input);

        var storedItems = [];
        var slides = container.querySelectorAll(slideSelector);
        slides.forEach((slide) => {
            var items = slide.querySelectorAll(itemSelector);
            items.forEach((item) => {
                storedItems.push(slide.removeChild(item));
            });
        });

        this.shuffleArray(storedItems);

        slides.forEach((slide) => {
            for (x=1;x<=6;x++) {
                if (storedItems.length < 1) {
                    break;
                }
                slide.appendChild(storedItems.pop());
            }
        });

    }

    shuffleArray(array) {
        let currentIndex = array.length;
        while (currentIndex != 0) {
          let randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex--;
          [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
        }
      }

    closeModalHandler() {
        const openModal = document.querySelector(
            '.team-group-card-section--list-item.show'
        );
        if (openModal) {
            openModal.classList.remove('show');
            document.body.classList.remove('has-open-modal');

            const keenSliderElements = openModal.querySelectorAll(
                '.keen-slider, .keen-slider__slide, .active-slide'
            );
            keenSliderElements.forEach((element) => {
                element.classList.remove(
                    'keen-slider',
                    'keen-slider__slide',
                    'active-slide'
                );
            });

            if (openModal.sliderInstance) {
                openModal.sliderInstance.destroy();
                openModal.classList.remove('slider-initialized');
                openModal.sliderInstance = null; // Clear the instance to avoid re-initialization
            }
        }
    }

    createSliderForModal(slideWrapper) {
        const slideContainer = slideWrapper.querySelector(
            '.team-group-card--slides-container'
        );
        const slides = slideContainer.querySelectorAll('.team-group-card--slide');

        if (slides.length >= 2) {
            slideContainer.classList.add('keen-slider');
            slides.forEach((slide) => {
                slide.classList.add('keen-slider__slide');
            });

            const slider = new KeenSlider(slideContainer, {
                loop: true,
                slidesPerView: 1,
                slidesPerGroup: 1,

                created: (instance) => {
                    const sliderPrevious = slideWrapper.querySelector('.team-group-card--prev');
                    const sliderNext = slideWrapper.querySelector('.team-group-card--next');

                    sliderPrevious.addEventListener('click', () => {
                        instance.prev();
                    });
                    sliderPrevious.addEventListener('keydown', this.previousTabHandler, true);

                    sliderNext.addEventListener('click', () => {
                        instance.next();
                    });
                    sliderNext.addEventListener('keydown', this.nextTabHandler, true);

                    const slides = slideWrapper.querySelectorAll('.team-group-card--slide a');
                    slides.forEach((slide) => {
                        slide.addEventListener('keydown', this.slideTabHandler, true);
                    });
                },
                afterChange: (instance) => {
                    const previousSlide = slideWrapper.querySelector('.active-slide');
                    const slides = slideWrapper.querySelectorAll('.team-group-card--slide');
                    const slideIndex = instance.details().relativeSlide;

                    if (slides[slideIndex]) {
                        slides[slideIndex].classList.add('active-slide');
                    } else {
                        console.warn(`Slide with index ${slideIndex} not found.`);
                    }

                    if (previousSlide) {
                        previousSlide.classList.remove('active-slide');
                    } else {
                        console.warn(`previousSlide not found.`);
                    }
                },
            });

            // Optionally store the slider instance if needed for further interactions
            slideWrapper.sliderInstance = slider;
        }
    }

    previousTabHandler(event) {
        if (Number(event.keyCode) === 9) {
            if (!event.shiftKey) {
                event.preventDefault();
                this.slideWrapper.querySelector('.active-slide a').focus();
            }
        }
    }

    nextTabHandler(event) {
        if (Number(event.keyCode) === 9) {
            if (event.shiftKey) {
                event.preventDefault();
                this.slideWrapper.querySelector('.active-slide a').focus();
            }
        }
    }
}

DrupalBehavior.register('summit_theme', 'team_group_cards', TeamGroupCards);
